export * as ED25519 from './ed25519/index.js';
export * as SECP256k1 from './secp256k1/index.js';
//# sourceMappingURL=index.js.map